import { type ReactNode, useMemo } from "react";
import IndicatorGrid from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/period-summary/indicator-grid/IndicatorGrid.tsx";
import RecapTable from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/period-summary/recap-table/RecapTable.tsx";
import { useReadPeriodSummary } from "@/pages/human-resources/time-management/services/hooks/useReadPeriodSummary.ts";
import type { PeriodSummaryRange } from "@/pages/human-resources/time-management/business/analysis/PeriodSummaryRange.ts";
import type { PeriodSummaryByMode } from "@/pages/human-resources/time-management/business/analysis/PeriodSummaryByMode.ts";
import type { PeriodSummaryMode } from "@/pages/human-resources/time-management/business/analysis/PeriodSummaryMode.ts";
import { CircularProgress } from "@mui/material";

interface Properties {
  domainId: string;
  siteId: string;
  date: Date;
  range: PeriodSummaryRange;
  mode: PeriodSummaryMode;
}

export default function PeriodSummaryCardBody(props: Properties): ReactNode {
  const { summaries, isFetching } = useReadPeriodSummary({
    domainId: props.domainId,
    siteId: props.siteId,
    date: props.date.toISOString(),
    modes: ["PREVIOUS_YEAR", "FORECAST", "TREND"],
    range: props.range,
  });

  const summaryByMode = useMemo<PeriodSummaryByMode>(() => {
    const result: Partial<PeriodSummaryByMode> = {};

    for (const summary of summaries) {
      result[summary.mode] = summary;
    }
    return result as PeriodSummaryByMode;
  }, [summaries]);

  return isFetching ?
      <div className="loading-progress">
        <CircularProgress />
      </div>
    : <div className="card-body">
        <IndicatorGrid summary={summaryByMode[props.mode]} />
        <RecapTable summaryByMode={summaryByMode} />
      </div>;
}
